// extracted by mini-css-extract-plugin
export var scrollArea = "_ob-0";